import styled from "styled-components";
import { RoundedBlock } from "./roundedBlock";

export const Card = styled(RoundedBlock)`
	border-radius: 25px;
	box-shadow: 0 4px 46px 0 rgba(0, 0, 0, 0.1);
`;
